import Dropdown from '@components/drop-down/Dropdown';

interface RowsPerPageSelectorProps {
  pageSize: number;
  options: number[];
  onPageSizeChange: (pageSize: number) => void;
}

const RowsPerPageSelector = ({
  pageSize,
  options,
  onPageSizeChange
}: RowsPerPageSelectorProps) => (
  <div className="flex items-center gap-2">
    <span className="whitespace-nowrap text-sm font-medium text-cofeeNeutral10">
      Rows per page
    </span>
    <Dropdown
      dropdownId="rows-per-page"
      listId="rows-per-page"
      currentFilter={String(pageSize)}
      filterOptions={options.map((option) => ({
        id: option,
        label: String(option),
        value: String(option)
      }))}
      onSelectFilter={(value) => onPageSizeChange(Number(value))}
      variant="v2"
      buttonClassName="h-9 min-w-20 rounded-lg border !border-cofeeNeutral4 !bg-cofeeNeutral1"
      usePortal
    />
  </div>
);

export default RowsPerPageSelector;
